import _taggedTemplateLiteral from "D:\\KODLAR\\ANADOLUNET\\anadoluegitimakademisi\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import styled from "styled-components";
import posed from "react-pose";
export const Floating = styled(posed.div({
  pressable: true,
  hover: {
    scale: 1.1
  },
  press: {
    x: 0,
    delay: 100
  },
  open: {
    x: props => props.number > 3 && (props.right ? -props.distance : props.distance),
    y: props => props.number > 6 && (props.top ? props.distance : -props.distance)
  },
  closed: {
    x: 0,
    y: 0,
    rotate: 0
  }
}))(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  top: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: ", ";\n  bottom: ", ";\n  right: ", ";\n  left: ", ";\n  z-index: 9999;\n"])), props => props.top ? "15" : "null", props => props.top ? "20px" : "none", props => !props.top ? "20px" : "none", props => props.right ? "20px" : "none", props => !props.right ? "20px" : "none");
export const Container = styled(posed.div({
  hoverable: true,
  pressable: true,
  init: {
    scale: 1
  },
  hover: {
    scale: 1.2
  },
  press: {
    scale: 0.8
  }
}))(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  height: ", "px;\n  width: ", "px;\n  border-radius: ", "px;\n  background-color: #8f1d30;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])), props => props.size, props => props.size, props => props.size);
export const Item = styled(posed.div({
  hoverable: true,
  pressable: true,
  init: {
    scale: 1
  },
  hover: {
    scale: 1.2
  },
  press: {
    scale: 0.8
  },
  enter: {
    y: props => Math.sin(props.i) * props.distance,
    x: props => Math.cos(props.i) * props.distance,
    opacity: 1,
    delay: 150,
    transition: {
      y: {
        type: "spring",
        stiffness: 500,
        damping: 10
      },
      x: {
        type: "spring",
        stiffness: 500,
        damping: 10
      },
      boxShadow: {
        delay: 300,
        type: "spring",
        stiffness: 500,
        damping: 10
      },
      default: {
        duration: 150
      }
    }
  },
  exit: {
    y: 0,
    x: 0,
    opacity: 0,
    transition: {
      duration: 150
    }
  }
}))(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  height: ", "px;\n  width: ", "px;\n  border-radius: ", "px;\n  background-color: #dbdbdb;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])), props => props.size, props => props.size, props => props.size);